<template>
    <span class="select2 select2-container select2-container--default">
        <span class="selection">
            <span class="select2-selection select2-selection--single"
                  role="combobox" aria-haspopup="true"
                  aria-expanded="false" tabindex="0" aria-disabled="false"
                  aria-labelledby="select2-searchPlaceholder-container">

                <span class="select2-selection__rendered"
                      id="select2-searchPlaceholder-container"
                      role="textbox"
                      aria-readonly="true">
                    <span v-if="location && location.query"
                          class="select2-selection__placeholder select2-selection__placeholder--with-location">{{ location.query }}
                    </span>

                    <span v-else
                          class="select2-selection__placeholder">{{ translate.home.searchPlaceholder }}
                    </span>
                </span>

                <span
                        class="select2-selection__arrow" role="presentation">
                    <b role="presentation"></b>
                </span>

            </span>
        </span>
        <span class="dropdown-wrapper"
              aria-hidden="true">

        </span>
    </span>
</template>

<script>
import IconComponent from "@/components/global/IconComponent.vue";

export default {
    components: {IconComponent},
    computed: {
        ...mapState(['location', 'translate'])
    },
}
</script>
